import { render } from "./TableColumnRemove.vue?vue&type=template&id=92c932c8"
import script from "./TableColumnRemove.vue?vue&type=script&lang=js"
export * from "./TableColumnRemove.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/TableColumnRemove.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "92c932c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('92c932c8', __exports__)) {
    api.reload('92c932c8', __exports__)
  }
  
  module.hot.accept("./TableColumnRemove.vue?vue&type=template&id=92c932c8", () => {
    api.rerender('92c932c8', render)
  })

}


export default __exports__